// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".returns-wrapper .returns-wrapper__hints[data-v-faba49ee]{position:relative;background-color:rgba(245,245,250,.7);border-radius:5px;padding:20px;margin-top:3px}.returns-wrapper .returns-wrapper__hints[data-v-faba49ee]:before{content:\"\";position:absolute;top:-8px;left:50%;transform:translateX(-50%) rotate(45deg);width:16px;height:16px;background-color:rgba(245,245,250,.7)}", ""]);
// Exports
module.exports = exports;
